class GeoFeature {
    constructor(id, coordinates, mapGeometryType, color = undefined, nodeSource = undefined, name = undefined, description = undefined, created = undefined) {
        this.id = id;
        this.coordinates = coordinates;
        this.mapGeometryType = mapGeometryType;
        this.color = color;
        this.nodeSource = nodeSource;
        this.name = name;
        this.description = description;
        this.created = created || Date.now();
    }
}
export default GeoFeature;
